import Splide from '@splidejs/splide';

const installSliders = document.querySelectorAll(
  '[data-control-installation-install-slider]'
);

function mountSlider(el) {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    gap: 30,
    classes: {
      pagination: 'control-installation-install__block-slider-pagination',
      page: 'control-installation-install__block-slider-pagination-btn',
    },
  }).mount();
}

export const initInstallSlider = () => {
  installSliders.forEach((slider) => {
    mountSlider(slider);
  });
};
